import { Component, OnInit, ViewChild } from '@angular/core';
import { SystemFlowService } from '../../../services/configuration/system-flow.service';
import { GenericModalService } from '../../../services/generic-modal.service';
import { BusinessProcessService } from '../../../services/business-process.service';
import { WfTableComponent } from '../../../common/table-sort/wf-table.component';
import { HttpEventType } from '@angular/common/http';
import { DateTimeService } from '../../../services/date-time.service';
import { SystemFlowModalComponent } from './system-flow-modal/system-flow-modal.component';
import { take } from 'rxjs/operators';
import { SystemFlowImportComponent } from './system-flow-import/system-flow-import.component';

@Component({
  selector: 'app-system-flow',
  templateUrl: './system-flow.component.html',
  styleUrls: ['./system-flow.component.css']
})
export class SystemFlowComponent implements OnInit {

  errorMessage = '';
  pleaseWait = false;
  filteredSystemFlowList = [];
  systemFlowList = [];
  hasRight: boolean;
  filterSettings = {
    placeholder: 'Filtrar',
    width: 100,
    inputTextSearchId: 'txtSearchGlobalVariable',
    textFilterPropertyNames: ['name', 'validationDescription'],
  };
  modalComponent: any = SystemFlowModalComponent;
  importComponent: any = SystemFlowImportComponent;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(private systemFlowService: SystemFlowService,
              private modalService: GenericModalService,
              private businessProcessService: BusinessProcessService,
              private dateTimeService: DateTimeService) { }

  ngOnInit() {
    this.getSystemFlowList();
    this.checkRights();
  }

  getSystemFlowList() {
    this.errorMessage = '';
    this.pleaseWait = true;
    this.systemFlowService.getAllSystemFlow()
      .subscribe( list => {
        this.filteredSystemFlowList = list;
        this.systemFlowList = list;
        this.pleaseWait = false;
      }, error1 => { this.errorMessage = error1; this.pleaseWait = false; });
  }

  getFlowIdByName(flow: any) {
    this.errorMessage = '';
    this.systemFlowService.getAllSystemFlow()
      .subscribe( list => {
        flow.flowId = list.find(item => item.name === flow.name).flowId;
        this.onEditSystemFlow(flow);
      }, error1 => this.errorMessage = error1);
  }

  onDeleteSystemFlow(systemFlow: any) {
    if (this.hasRight) {
      this.errorMessage = '';
      let alert: any;
      alert = this.modalService
        .showConfirmModal('Confirmação de Exclusão', `Confirma a exclusão do fluxo de sistema <b>${systemFlow.name}</b>?`);
      alert.then( resp => {
        if (resp.value) {
          delete systemFlow['extensionData'];
          this.systemFlowService.removeSystemFlow(systemFlow)
            .subscribe( () => {
                this.ngOnInit();
              },
              error1 => {
                this.errorMessage = error1;
              });
        }
      });
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onDownloadFlow(flow) {
    this.errorMessage = '';
    this.systemFlowService.exportSystemFlow(flow.flowId, flow.name).subscribe(
      data => {
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            console.log('Exportação status: ' + Math.round((data.loaded / data.total) * 100) + '%');
            break;
          case HttpEventType.Response:
            const timeStamp = this.dateTimeService.getLocalTimeStamp();
            const downloadedFile = new Blob([data.body], { type: data.body.type });
            const a = document.createElement('a');
            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.download = encodeURIComponent(flow.name + timeStamp + '.systemflow');
            a.href = URL.createObjectURL(downloadedFile);
            a.target = '_blank';
            a.click();
            document.body.removeChild(a);
            break;
        }
      },
      error1 => {
        const errorMsg = `Erro ao realizar a exportação do fluxo de sistema: ${error1}`;
        this.errorMessage = errorMsg;
        console.log(errorMsg);
      }
    );
  }

  onEditSystemFlow(systemFlow) {
    if (this.hasRight) {
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Editar fluxo de sistema', systemFlow);
      result$.asObservable()
        .subscribe(
          flow => {
            if (flow.justCreatedOrUpdated) { this.ngOnInit(); }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onAddFlow() {
    if (this.hasRight) {
      const newFlow = { };
      const result$ = this.modalService.showObjModal(this.modalComponent, 'Criar Fluxo de Sistema', newFlow);
      result$.asObservable()
        .subscribe(
          flow => {
            if (flow.name) {
              this.getFlowIdByName(flow);
            }
          }
        );
    } else {
      this.modalService.showErrorMessage('Usuário não tem direito a efetuar essa ação.', true);
    }
  }

  onImportFlow() {
    const result$ = this.modalService.showModal(this.importComponent, 'Importar Fluxos de Sistema', 0, null, 'modal-xl');
    result$.asObservable()
      .pipe(take(1))
      .subscribe(result => {
        if (result) {
          setTimeout(() => {
            this.ngOnInit();
          }, 2000);
        }
      });
  }

  checkRights() {
    this.errorMessage = '';
    this.businessProcessService.checkRights(4194304)
      .subscribe( rights => {
        this.hasRight = rights.length > 0;
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  onFilterList(filteredData: any[]) {
    this.filteredSystemFlowList = filteredData;
  }

}
